function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

export function extractErrorDetail(error: unknown): string | undefined {
  if (!isRecord(error)) {
    return undefined;
  }

  let body: unknown;
  if ("response" in error && isRecord(error.response)) {
    body = "data" in error.response ? error.response.data : error.response.body;
  }

  if (isRecord(body)) {
    if (
      "displayableMessage" in body &&
      typeof body.displayableMessage === "string" &&
      body.displayableMessage.length > 0
    ) {
      return body.displayableMessage;
    }
    if (
      "errors" in body &&
      Array.isArray(body.errors) &&
      isRecord(body.errors[0]) &&
      typeof body.errors[0].detail === "string" &&
      body.errors[0].detail.length > 0
    ) {
      return body.errors[0].detail;
    }
    if ("message" in body && typeof body.message === "string" && body.message.length > 0) {
      return body.message;
    }
    if ("error" in body && typeof body.error === "string" && body.error.length > 0) {
      return body.error;
    }
  } else if (typeof body === "string" && body.length > 0 && !body.trimStart().startsWith("<")) {
    // Axios can deliver plain-string error bodies in `response.data` when the
    // backend returns a non-JSON payload. Skip HTML to avoid rendering raw
    // markup in a toast.
    return body;
  }

  // Fall back to superagent's plain-text error body when the structured body
  // is absent or doesn't contain a recognized message field. Skip empty
  // strings and HTML payloads (e.g. 502 gateway pages).
  if (
    "response" in error &&
    isRecord(error.response) &&
    "text" in error.response &&
    typeof error.response.text === "string" &&
    error.response.text.length > 0 &&
    !error.response.text.trimStart().startsWith("<")
  ) {
    return error.response.text;
  }

  if ("message" in error && typeof error.message === "string" && error.message.length > 0) {
    return error.message;
  }

  return undefined;
}
